import { ready } from '../../app/support/utils';
import HttpMethod from '../../app/enums/HttpMethod';
import Practitioner from '../../app/models/Practitioner';
import CalendarEvent from '../../app/models/CalendarEvent';
import { renderCalendarDesktopHeader, renderPractitionerAvailabilities } from './helpers';
import { now, localizedRoute, moment, parseId } from '../../app/support/helpers';

var practitioners: Practitioner[];

ready(() => {

    nextAvailability();

    practitioners = Practitioner.new(window.doctori.practitioners as []);

    const operatingPractitioners = practitioners.filter(practitioner => practitioner.operating_business_days.length > 0);

    operatingPractitioners.forEach((practitioner: Practitioner) => {
        const start = now();
        const end   = now().add(6, 'days');

        $.ajax({
            url: localizedRoute('frontend.practitioners.availabilities', practitioner.id),
            type: HttpMethod.GET,
            cache: false,
            dataType: 'json',
            data: {
                start: start.format(window.moment.HTML5_FMT.DATE),
                end: end.format(window.moment.HTML5_FMT.DATE),
            },
            beforeSend: () => {}
        })
        .done((response) => {
            const calendarEvents = CalendarEvent.new(response as []);
            const html = renderPractitionerAvailabilities(practitioner, calendarEvents, {start, end});
            document.querySelector(`.listingCalendar_${ practitioner.id }`).innerHTML = html;
        })
        .fail((response) => {
        })
        .always(() => {});
    });



    $(document).on('click','.more', function (e) {
        e.preventDefault();
        $(this).closest('.liste_times').find('.more').hide();
        $(this).closest('.liste_times').find('.times').find('.date_top').hide();
        $(this).closest('.liste_times').find('.times').find('.date_bottom').show();
    });

    $(document).off('click', '.nav_right_top').on('click', '.nav_right_top', function(event) {
        event.preventDefault();

        $(".nav_right_mb").off('click').click();
    });

    $(document).off('click', '.nav_left_top').on('click', '.nav_left_top', function(event) {
        event.preventDefault();

        $(".nav_left_mb").off('click').click();
    });

    $(document).on('click', '.nav_right_mb', function(e) {
        e.preventDefault();

        var $navControl = $(this);
        var id          = $(this).closest('.table_right').find('.doc').val() as string;
        var cuurent_day = $(this).closest('.table_right').find('.cuurent_day').val() as string;
        var speciality  = $(this).closest('.table_right').find('.calendar_speciality').val();
        var now         = new Date();
        var date_start  = new Date(cuurent_day);
        var date_end    = new Date(cuurent_day);

        date_start.setDate(date_start.getDate() + 7);
        date_end.setDate(date_end.getDate() + 13);

        var Dstart = date_start.getFullYear() + "-" + ("0" + (date_start.getMonth() + 1)).slice(-2) + "-" + ("0" + date_start.getDate()).slice(-2);
        var Dend   = date_end.getFullYear() + "-" + ("0" + (date_end.getMonth() + 1)).slice(-2) + "-" + ("0" + date_end.getDate()).slice(-2);

        if (now <= date_start) {
            $('.nav_left_top').show();
            $(this).closest('.table_right').find('.cuurent_day').val(Dstart);
        }
        else {
            $('.nav_left_top').hide();
        }

        $.ajax({
            url: localizedRoute('frontend.practitioners.availabilities', id),
            type: HttpMethod.GET,
            cache: false,
            data: {
                start: Dstart,
                end: Dend,
            },
            beforeSend: () => {
                disableCalendarNavControllers();
                showCalendarLoaderById(id);
                showCalendarLoader();
            }
        })
        .done((response) => {
            const calendarEvents = CalendarEvent.new(response as []);
            const practitioner   = practitioners.find(practitioner => practitioner.id === parseId(id));
            const availabilities = renderPractitionerAvailabilities(practitioner, calendarEvents, {start: moment(Dstart), end: moment(Dend)});
            document.querySelector(`.listingCalendar_${id}`).innerHTML = availabilities;
            const calendarHeader = renderCalendarDesktopHeader({start: moment(Dstart), end: moment(Dend)});
            document.querySelector(`.desktopHeader`).innerHTML = calendarHeader;
            // @ts-ignore
            window.showPhoneEvent();
        })
        .fail((response) => {
        })
        .always(() => {
            enableCalendarNavControllers();
            hideCalendarLoaderById(id);
            hideCalendarLoader();
        });

        return false;
    });


    $(document).on('click', '.nav_left_mb', function (e) {
        e.preventDefault();

        var $arrowNav   = $(this);
        var id          = $(this).closest('.table_right').find('.doc').val() as string;
        var cuurent_day = $(this).closest('.table_right').find('.cuurent_day').val() as string;
        var speciality  = $(this).closest('.table_right').find('.calendar_speciality').val();
        var now         = new Date();
        var date_start  = new Date(cuurent_day);
        var date_end    = new Date(cuurent_day);

        date_start.setDate(date_start.getDate() - 7);
        date_end.setDate(date_end.getDate() - 1);

        var Dstart = date_start.getFullYear() + "-" + ("0" + (date_start.getMonth() + 1)).slice(-2) + "-" + ("0" + date_start.getDate()).slice(-2);
        var Dend = date_end.getFullYear() + "-" + ("0" + (date_end.getMonth() + 1)).slice(-2) + "-" + ("0" + date_end.getDate()).slice(-2);

        var Dnow = now.getFullYear() + "-" + ("0" + (now.getMonth() + 1)).slice(-2) + "-" + ("0" + now.getDate()).slice(-2);
        var dataString = {'id': id, 'Dstart': Dstart, 'Dend': Dend,  'speciality': speciality, 'action': 'prev'}

        $.ajax({
            url: localizedRoute('frontend.practitioners.availabilities', id),
            type: HttpMethod.GET,
            cache: false,
            data: {
                start: Dstart,
                end: Dend,
            },
            beforeSend: () => {
                disableCalendarNavControllers();
                showCalendarLoaderById(id);
                showCalendarLoader();
            }
        })
        .done((response) => {
            const calendarEvents = CalendarEvent.new(response as []);
            const practitioner   = practitioners.find(practitioner => practitioner.id === parseId(id));
            const availabilities = renderPractitionerAvailabilities(practitioner, calendarEvents, {start: moment(Dstart), end: moment(Dend)});
            document.querySelector(`.listingCalendar_${id}`).innerHTML = availabilities;
            const calendarHeader = renderCalendarDesktopHeader({start: moment(Dstart), end: moment(Dend)});
            document.querySelector(`.desktopHeader`).innerHTML = calendarHeader;

            // @ts-ignore
            window.showPhoneEvent();
        })
        .fail((error) => {
        })
        .always(() => {
            enableCalendarNavControllers();
            hideCalendarLoaderById(id);
            hideCalendarLoader();
        });
    });

    function disableCalendarNavControllers(): void {
        disableCalendarNavControllersForDesktop();
        disableCalendarNavControllersForMobile();
    }

    function enableCalendarNavControllers(): void {
        enableCalendarNavControllersForDesktop();
        enableCalendarNavControllersForMobile();
    }

    //////////////////////////////////////////////////
    // Desktop
    //////////////////////////////////////////////////

    function disableCalendarNavControllersForDesktop(): void {
        disableCalendarRightNavControllerForDesktop();
        disableCalendarLeftNavControllerForDesktop();
    }

    function enableCalendarNavControllersForDesktop(): void {
        enableCalendarRightNavControllerForDesktop();
        enableCalendarLeftNavControllerForDesktop();
    }

    function disableCalendarRightNavControllerForDesktop(): void {
        document.querySelector('.nav_right_top').classList.add('disabled_link');
    }

    function enableCalendarRightNavControllerForDesktop(): void {
        document.querySelector('.nav_right_top').classList.remove('disabled_link');
    }

    function disableCalendarLeftNavControllerForDesktop(): void {
        document.querySelector('.nav_left_top').classList.add('disabled_link');
    }

    function enableCalendarLeftNavControllerForDesktop(): void {
        document.querySelector('.nav_left_top').classList.remove('disabled_link');
    }

    //////////////////////////////////////////////////
    // Mobile
    //////////////////////////////////////////////////

    function disableCalendarNavControllersForMobile(): void {
        disableCalendarRightNavControllerForMobile();
        disableCalendarLeftNavControllerForMobile();
    }

    function enableCalendarNavControllersForMobile(): void {
        enableCalendarRightNavControllerForMobile();
        enableCalendarLeftNavControllerForMobile();
    }

    function disableCalendarRightNavControllerForMobile(): void {
        document.querySelector('.nav_right_mb').classList.add('disabled_link');
    }

    function enableCalendarRightNavControllerForMobile(): void {
        document.querySelector('.nav_right_mb').classList.remove('disabled_link');
    }

    function disableCalendarLeftNavControllerForMobile(): void {
        document.querySelector('.nav_left_mb').classList.add('disabled_link');
    }

    function enableCalendarLeftNavControllerForMobile(): void {
        document.querySelector('.nav_left_mb').classList.remove('disabled_link');
    }

    function showCalendarLoaderById(id: number|string): void {
        document.querySelector(`.listingCalendar_${id}`)
            .querySelector('.bar-loader')
            .classList.remove('hidden');
    }

    function hideCalendarLoaderById(id: number|string): void {
        document.querySelector(`.listingCalendar_${id}`)
            .querySelector('.bar-loader')
            .classList.add('hidden');
    }

    function showCalendarLoader(): void {
        document.querySelector('.desktopHeader')
            .querySelector('.bar-loader')
            .classList.remove('hidden');
    }

    function hideCalendarLoader(): void {
        document.querySelector('.desktopHeader')
            .querySelector('.bar-loader')
            .classList.add('hidden');
    }

    function nextAvailability() {

        $(document).off().on('click', '.nextAvailability', function(event) {
            event.preventDefault();

            var nextAvailabilityData = CalendarEvent.new($(event.target).data('nextAvailability') as {});

            // the behavior of "get next week appointments" is it adds 7 days
            // to the current day to get get the next week
            // so we make our current day set to one week before
            // to keep "get next week appointments" behavior consistent
            let start  = new Date(nextAvailabilityData.start);

            start.setDate(start.getDate() - 7);

            const $calBox = $(event.target).closest('.cal_box');

            $calBox.find('.doc').val(nextAvailabilityData.practitioner_id);
            $calBox.find('.cuurent_day').val(moment(start).format('YYYY-MM-DD'))
            $calBox.find(".nav_right_mb").off('click').click();
        });
    }
});
